var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.isMain)?_c('app-banner',{staticClass:"hidden-xs-only",attrs:{"locale":_vm.$vuetify.lang.current}}):_vm._e(),_c('router-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }